import type { DropdownChangeEvent } from "primereact/dropdown";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { PAGE_HEADER_TABS_LABEL } from "../../messages";
import { usePageHeaderTabs } from "../../use-page-header-tabs";
import type { PageHeaderTabSelectProps, PageHeaderTabSelectViewModel } from "./types-tab-select";

/** ViewModel do `TabSelect` (abas no mobile): opções do `Dropdown`, rota ativa como valor e navegação ao escolher; sem JSX. */
export function useTabSelect({
  items,
  "aria-label": ariaLabel = PAGE_HEADER_TABS_LABEL,
  mobileQuery,
  className,
  ...rest
}: PageHeaderTabSelectProps): PageHeaderTabSelectViewModel {
  const navigate = useNavigate();
  const { activeItem } = usePageHeaderTabs(items, { mobileQuery });

  const options = useMemo(
    () => items.map((item) => ({ label: item.label, value: item.to, disabled: item.disabled })),
    [items],
  );

  const onChange = useCallback(
    (event: DropdownChangeEvent) => {
      if (event.value) navigate(event.value);
    },
    [navigate],
  );

  return { options, value: activeItem?.to ?? null, onChange, ariaLabel, className, rest };
}
